import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, DialogTitle as MuiDialogTitle, } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { styled } from '@mui/material/styles';
import Optional from '../fields/Optional';
import ColoredButton from '../button/ColoredButton';
const DialogTitleRoot = styled(MuiDialogTitle, {
    name: 'DialogTitle',
    slot: 'root',
})({
    display: 'flex',
});
const DialogTitleContent = styled(Box, {
    name: 'DialogTitle',
    slot: 'titleContent',
})(({ theme }) => ({
    justifyContent: 'center',
    margin: 0,
    alignSelf: 'center',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: '100%',
    textAlign: 'center',
    fontSize: '26px',
    padding: '0 20px',
    [theme.breakpoints.down('sm')]: {
        fontSize: '15px',
    },
}));
const renderButtons = (buttons) => buttons.map((coloredButtonProps, index) => (_jsx(ColoredButton, Object.assign({ variant: "contained" }, coloredButtonProps), `base-dialog-button-${index}`)));
const DialogTitleCloseButton = styled(IconButton, {
    name: 'DialogTitle',
    slot: 'closeButton',
})({});
export default function DialogTitle(props) {
    const { title, onClose, headerButtonsLeft, headerButtonsRight, showCloseButton = true, } = props;
    const OptionalCloseButton = Optional(() => (_jsx(DialogTitleCloseButton, { "aria-label": "close", onClick: onClose, size: "large", children: _jsx(CloseIcon, {}) })));
    return (_jsxs(DialogTitleRoot, { children: [renderButtons(headerButtonsLeft || []), _jsx(DialogTitleContent, { children: title }), renderButtons(headerButtonsRight || []), _jsx(OptionalCloseButton, { renderIf: showCloseButton })] }));
}
